module.exports = __webpack_public_path__ + "static/media/cert-moisture.6276f726.png";